import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { useSideMenuMobile } from "./hooks";
import { SideMenuMobilePresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const SideMenuMobileContainer = ({ hotelID }: Props) => {
	const { sideMenuData, hotelApplicationData } = useSideMenuMobile({
		hotelID,
	});

	if (!sideMenuData) {
		return <Navigate to={generatePath(PATHS.TOP)} />;
	}

	return (
		<SideMenuMobilePresenter
			hotelID={hotelID}
			sideMenuData={sideMenuData}
			hotelApplicationData={hotelApplicationData}
		/>
	);
};

SideMenuMobileContainer.displayName = "SideMenuMobileContainer";
